import React, { Component } from "react"
import {
  HeadingBlock,
  ConfiguredVehicle,
  SpecificationList
} from "containers"
import { withRadium, ConnectLocation } from "higher-order-components"
import { WINDOW, IS_MOBILE } from "constants/environment"
import { SummaryWithPrice, Hyperlink } from "components"
import { SaveForm, ShareForm, Tooltip } from "AtomicContainers"
import { A, P, H2, H6, Section, Interactive, SaveIcon, ShareIcon, Modal, Caption } from "AtomicComponents"
import { MobileShare } from "containers"
import COLOR_PALETTE from "constants/color-palette"
import { SaveShareCopy } from "AtomicContainers"
import gtmHandler from "../../AtomicUtils/gtmHandler";

const getShortModel = modelName => (modelName.split(" ")[1] || modelName.split(" ")[0]).toUpperCase()

class BuildSummaryStep extends Component {
  constructor(props) {
    super(props)
    this.state = {
      saveFormOpen: false,
      shareFormOpen: false,
      showMobileShare: true,
      showTooltipOfSaveInSummary: false
    }
  }


  componentDidMount() {
    const { disableSavePrompt = false, delayToShowSavePrompt = 1000, delayToCloseSavePrompt = 3000 } = this.props
    if (!disableSavePrompt) {
      setTimeout(() => {
        this.setState({
          showTooltipOfSaveInSummary: true
        }, () => {
          setTimeout(() => {
            this.setState({
              showTooltipOfSaveInSummary: false
            })
          }, delayToCloseSavePrompt)
        })
      }, delayToShowSavePrompt)
    }
  }

  _handleClickOnOpeningSaveModal = () => {
    this.setState({ saveFormOpen: true }, () => {
      this.props.gtmEvent({
        gtmID: this.props.gtmBuildToolActionTypes.BUILDTOOL_CLICKED_SAVE,
        gtmPayload: {
          modelName: this.props.options.nameplate.name,
          stepNumber: this.props.activeStep,
          stepName: this.props.stepData.name,
          bodyName: this.props.options.bodyStyle.name,
          driveName: this.props.options.drivetrain.name,
          gradeName: this.props.options.grade.name,
          colorName: this.props.options.color.name,
          interiorName: this.props.options.interiorDesign.name
        }
      })
    })
  }

  _renderShareSection = () => {
    const currentPrice = ((this.props.price || {}).data || [])[0] || {}
    const { includeSafetyModel, safetyModelExcess, financeOptionText = false } = this.props
    const { showTooltipOfSaveInSummary } = this.state
    return (
      <div data-test="share-build" style={styles.shareSection}>
        <div style={{ position: "relative" }} key="SavePart">
          <div style={styles.shareSectionColumn} onClick={this._handleClickOnOpeningSaveModal}>
            <div>
              <SaveIcon style={styles.shareSectionIcon} />
            </div>
            <div style={styles.shareSectionText} key="SaveText">
              <Interactive>SAVE</Interactive>
            </div>
          </div>
          {showTooltipOfSaveInSummary &&
            <Tooltip position="bottomRight">
              <div style={{ letterSpacing: 0 }}>
                <P withoutMargin>
                  You can now <A onClick={this._handleClickOnOpeningSaveModal}> save your {this.props.options.nameplate.name} </A> for future reference.
                </P>
              </div>
            </Tooltip>
          }
        </div>
        {
          this.state.saveFormOpen &&
          <Modal
            width="600px"
            handleClose={() => {
              this.setState({ saveFormOpen: false })
            }}>
            <SaveForm
              endPoint={this.props.savedBuildEndPoint}
              imageSrc={[this.props.options.color.imageSrc]}
              description={"Save time and conveniently save your ideal Mazda now for future reference."}
              testDriveUrl={this.props.testDriveUrl}
              buildUrl={WINDOW.location.href}
              location={this.props.locationState}
              namePlate={this.props.options.nameplate.name}
              bodyStyle={this.props.options.bodyStyle.name}
              safetyModelExcess={includeSafetyModel && currentPrice.safetyModelPrice ? (currentPrice.price === currentPrice.safetyModelPrice ? "Included as standard" : `+$${safetyModelExcess}`) : null}
              financeOptionText={financeOptionText}
              gtmEvents={{ category: "Build Tool", action: `Build ${this.props.options.nameplate.name} ${this.props.options.bodyStyle.name} ${this.props.options.drivetrain.name} ${this.props.options.grade.name} ${this.props.options.color.name} ${this.props.options.interiorDesign.name}` }}
              fullWidth
              handleClose={() => {
                this.setState({ saveFormOpen: false })
              }} />
          </Modal>
        }
        <div
          onClick={() => {
            this.setState({ shareFormOpen: true }, () => {
              this.props.gtmEvent({
                gtmID: this.props.gtmBuildToolActionTypes.BUILDTOOL_CLICKED_SHARE,
                gtmPayload: {
                  modelName: this.props.options.nameplate.name,
                  stepNumber: this.props.activeStep,
                  stepName: this.props.stepData.name,
                  bodyName: this.props.options.bodyStyle.name,
                  driveName: this.props.options.drivetrain.name,
                  gradeName: this.props.options.grade.name,
                  colorName: this.props.options.color.name,
                  interiorName: this.props.options.interiorDesign.name
                }
              })
            })
          }}
          key="SharePart"
          style={styles.shareSectionColumn}>
          <div>
            <ShareIcon style={styles.shareSectionIcon} />
          </div>
          <div style={styles.shareSectionText} key="ShareText">
            <Interactive>SHARE</Interactive>
          </div>
        </div>
        {
          this.state.shareFormOpen &&
          <Modal
            width="600px"
            handleClose={() => {
              this.setState({
                shareFormOpen: false,
                showShareForm: false,
                showMobileShare: true
              })
            }}>
            {(IS_MOBILE && this.state.showMobileShare) &&
              <MobileShare
                imageSrc={this.props.options.color.imageSrc}
                mobileDescription={`How would you like to share your ${this.props.options.nameplate.name} ${this.props.options.bodyStyle.name} build?`}
                description={`Check out the ${this.props.options.nameplate.name + " " + this.props.options.bodyStyle.name} I built: `}
                EmailShareFunc={() => {
                  this.setState({
                    showShareForm: true,
                    showMobileShare: false
                  })
                }} />
            }
            {(!IS_MOBILE || this.state.showShareForm) &&
              <ShareForm
                endPoint={this.props.sharedBuildEndPoint}
                imageSrc={[this.props.options.color.imageSrc]}
                namePlate={this.props.options.nameplate.name}
                bodyStyle={this.props.options.bodyStyle.name}
                description={"Send the URL of your Mazda build via email"}
                compact={this.props.compact}
                buildUrl={WINDOW.location.href}
                location={this.props.locationState}
                safetyModelExcess={includeSafetyModel && currentPrice.safetyModelPrice ? (currentPrice.price === currentPrice.safetyModelPrice ? "Included as standard" : `+$${safetyModelExcess}`) : null}
                gtmEvents={{ category: "Build Tool", action: `Build ${this.props.options.nameplate.name} ${this.props.options.bodyStyle.name} ${this.props.options.drivetrain.name} ${this.props.options.grade.name} ${this.props.options.color.name} ${this.props.options.interiorDesign.name}` }}
                fullWidth
                handleClose={() => {
                  this.setState({ shareFormOpen: false })
                }} />
            }
          </Modal>
        }
      </div>
    )
  }

  _renderCompact = () => {
    const currentPrice = ((this.props.price || {}).data || [])[0] || {}
    const { mainHeading, options, includeSafetyModel, safetyModel, hideLinks, finance } = this.props

    return (
      <div>
        <div style={stepStyles.stepHeader}>
          <Section horizontalPadding>
            <HeadingBlock
              tag="h3"
              value={mainHeading}
              align={"center"}
              customPreHeadingStyle={{ fontSize: "94%" }} />
          </Section>
          <div style={{ maxWidth: "70%", padding: "2em 0 0", margin: "auto" }}>
            <ConfiguredVehicle src={options.color.imageSrc} />
          </div>
          <div style={{ padding: "0 20px" }}>
            <SummaryWithPrice
              heading={false}
              includeSafetyModel={includeSafetyModel}
              safetyModel={options.engine.safetyModelCode ? safetyModel : null}
              price={currentPrice}
              gtm={{
                category: `Build Tool "${options.nameplate.name.toUpperCase()}"`,
                action: `Build "${options.nameplate.name.toUpperCase()}" - Step 4 Summary - Clicked "PRICE DISCLAIMER"`
              }}
              items={[
                {
                  label: "Grade",
                  value: options.grade.name,
                  step: 3,
                  onClick: () => this.props.setStep(this.getGradeStepNumber())
                },
                {
                  label: "Drive & Transmission",
                  value:
                    options.drivetrain.name + " " + options.transmission.name
                },
                { label: "Engine", value: options.engine.name },
                {
                  label: "Exterior",
                  value: options.color.name,
                  border: true,
                  priceDifference: options.color.priceDifference,
                  step: 4,
                  onClick: () => this.props.setStep(this.getColorStepNumber())
                },
                { label: "Interior", value: options.interiorDesign.name }
              ]} />
            {
              finance && (
                <div style={styles.financeOption}>
                  <img
                    style={styles.financeIcon}
                    src={finance.icon} />
                  <A
                    href={finance.link}
                    external
                    gtm={{
                      category: `Build Tool "${options.nameplate.name}"`,
                      action: `Build "${options.nameplate.name}" - Step 4 SUMMARY - Clicked "FINANCE"`
                    }}>
                    <Caption>
                      {finance.description}
                    </Caption>
                  </A>
                </div>
              )
            }
            {/* <SaveShareCopy
              imageSrc={this.props.options.color.imageSrc}
              testDriveUrl={this.props.testDriveUrl}
              buildUrl={WINDOW.location.href}
              location={this.props.locationState}
              namePlate={this.props.options.nameplate.name}
              bodyStyle={this.props.options.bodyStyle.name}
              saveEndPoint={this.props.savedBuildEndPoint}
              shareEndPoint={this.props.sharedBuildEndPoint} /> */}
            {!hideLinks && this._renderShareSection()}
          </div>
        </div>
      </div>
    )
  }

  _render = () => {
    const currentPrice = ((this.props.price || {}).data || [])[0] || {}
    const { mainHeading, stepData, options, gtmEventPriceDisclaimer, includeSafetyModel, safetyModel, hideLinks, finance } = this.props

    return (
      <div>
        <div style={stepStyles.stepHeader}>
          <H6 withDetails>
            {mainHeading}
          </H6>
          <H2
            withDetails
            align={'center'}
          >
            {stepData.heading}
          </H2>
          <div style={{
            display: "flex", maxWidth: "85vw", margin: "auto", paddingTop: "4em"
          }}>
            <div style={{ flex: "0 1 50%" }}>
              <SummaryWithPrice
                heading={
                  options.nameplate.name + " " + options.bodyStyle.name
                }
                safetyModel={options.engine.safetyModelCode ? safetyModel : null}
                includeSafetyModel={includeSafetyModel}
                price={currentPrice}
                gtm={{
                  category: `Build Tool "${options.nameplate.name.toUpperCase()}"`,
                  action: `Build "${options.nameplate.name.toUpperCase()}" - Step 4 Summary - Clicked "PRICE DISCLAIMER"`
                }}
                items={[
                  {
                    label: "Grade",
                    value: options.grade.name,
                    onClick: () => this.props.setStep(this.getGradeStepNumber())
                  },
                  {
                    label: "Drive & Transmission",
                    value:
                      options.drivetrain.name +
                      " " +
                      options.transmission.name
                  },
                  { label: "Engine", value: options.engine.name },
                  {
                    label: "Exterior",
                    value: options.color.name,
                    border: true,
                    priceDifference: options.color.priceDifference,
                    onClick: () => this.props.setStep(this.getColorStepNumber())
                  },
                  { label: "Interior", value: options.interiorDesign.name }
                ]} />
              {
                finance && (
                  <div style={styles.financeOption}>
                    <img
                      style={styles.financeIcon}
                      src={finance.icon} />
                    <A
                      href={finance.link}
                      external
                      gtm={{
                        category: `Build Tool "${options.nameplate.name}"`,
                        action: `Build "${options.nameplate.name}" - Step 4 SUMMARY - Clicked "FINANCE"`
                      }}>
                      <Caption>
                        {finance.description}
                      </Caption>
                    </A>
                  </div>
                )
              }
              {/* <SaveShareCopy
                imageSrc={this.props.options.color.imageSrc}
                testDriveUrl={this.props.testDriveUrl}
                buildUrl={WINDOW.location.href}
                location={this.props.locationState}
                namePlate={this.props.options.nameplate.name}
                bodyStyle={this.props.options.bodyStyle.name}
                saveEndPoint={this.props.savedBuildEndPoint}
                shareEndPoint={this.props.sharedBuildEndPoint} /> */}
              {!hideLinks && this._renderShareSection()}
            </div>
            <div style={{ display: "flex" }}>
              <ConfiguredVehicle src={options.color.imageSrc} />
            </div>
          </div>
        </div>
      </div>
    )
  }

  getGradeStepNumber = () => {
    let gradeStepNumber = 0
    this.props.allData.forEach((item, index) => {
      if (item.name === "Grade") {
        gradeStepNumber = index
      }
    })
    return gradeStepNumber
  }

  getColorStepNumber = () => {
    let colorStepNumber = 0
    this.props.allData.forEach((item, index) => {
      if (item.name === "Color") {
        colorStepNumber = index
      }
    })
    return colorStepNumber
  }

  render() {
    return (
      <div>
        <div>{this.props.compact ? this._renderCompact() : this._render()}</div>
        <div>
          {this.props.specifications &&
            this.props.specifications.data && (
              <div style={{ maxWidth: "850px", margin: "0 auto", padding: "0 20px" }}>
                <SpecificationList
                  alwaysOpen={!this.props.stepData.summary}
                  key={this.props.stepData.summary ? "summary" : "other"}
                  gtmEventsDisclaimers={this.props.gtmEventsDisclaimers}
                  specs={this.props.specifications.data.categories.map((item) => {
                    item.onClick = (status) => {
                      gtmHandler({
                        pageAction: `Build "${getShortModel(this.props.options.nameplate.name)}" - Step ${this.props.activeStep} SUMMARY- ${status===1? 'Opened': 'Closed'} Feature Specs`,
                        pageCategory: `Build Tool "${getShortModel(this.props.options.nameplate.name)}"`
                      })
                    }
                    return item
                  })} />
                {this.props.stepData.summary && (
                  <div style={{ textAlign: "right", padding: "20px 0em 5em", width: "100%" }}>
                    <Hyperlink
                      gtmEvents={this.props.gtmEventsFullSpecLink}
                      external={this.props.fullSpecCta.external}
                      href={`${this.props.fullSpecCta.href}${this.props.search.queryString}`}>
                      {this.props.fullSpecCta.label} ›
                    </Hyperlink>
                  </div>
                )}
              </div>
            )}
        </div>
      </div>
    )
  }
}
export default withRadium(ConnectLocation())(BuildSummaryStep)

const stepStyles = {
  divider: {
    height: "2em",
    width: "1px",
    margin: "0px 1.8em 0 1.7em",
    background: "#cbcbcb",
    transform: "rotate(30deg)",
    display: "inline-block",
    verticalAlign: "middle"
  },
  stepHeader: {
    paddingTop: "30px",
    minHeight: "20vh"
  }
}
const styles = {
  link: {
    color: "#aaa",
    textDecoration: "none",
    fontSize: "90%",
    padding: "0em 0em 5em",
    ":hover": {
      color: "#101010"
    }
  },
  shareSection: {
    display: "inline-flex",
    width: "100%",
    maxWidth: "350px",
    justifyContent: "space-around",
    flex: "1 1 auto",
    margin: "auto",
    borderTop: "1px solid rgb(221, 221, 221)",
    padding: "2em 0em 4em 0em"
  },
  shareSectionColumn: {
    display: "flex",
    position: "relative",
    cursor: "pointer",
    color: COLOR_PALETTE.GRAY_DARKER,
    ":hover": {
      color: COLOR_PALETTE.RED
    }
  },
  shareSectionIcon: {
    height: "22px",
    width: "22px"
  },
  shareSectionText: {
    fontWeight: "bold",
    fontSize: "80%",
    letterSpacing: ".2em",
    color: COLOR_PALETTE.GRAY_DARKER,
    padding: "0 7px",
    whiteSpace: "nowrap"
  },
  financeOption: {
    display: 'flex',
    maxWidth: '350px',
    width: '100%',
    margin: '0 auto 18px auto',
    alignItems: 'center',
  },
  financeIcon: {
    marginRight: '10px',
    width: '15px'
  }
}



// WEBPACK FOOTER //
// ./src/containers/build/build-summary-step.jsx